import * as React from "react"
import { createRoot } from "react-dom/client"
import App from "./App.tsx"

// Registering here (not merely at the moment the user flips the
// notifications toggle) means a returning subscriber's push subscription
// is already backed by a live registration the instant the app loads —
// registering a service worker is silent, it never itself prompts for the
// OS notification permission the toggle actually needs.
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => {})
}

createRoot(document.getElementById("pv-app")).render(<App />)
